module.exports = __webpack_public_path__ + "static/VaishnaviSingh-a80ac90e2c91bd2099c7390b7c921790.jpg";